// ============================================================================
// CENTRALIZED TRANSLATIONS — edit all site copy here (FR default, NL, TR, EN)
// ============================================================================

const services6 = (t) => t; // helper marker

export const translations = {
  fr: {
    langLabel: "Français",
    seo: {
      home: { title: "Entretien, mécanique & pneus à Bruxelles", description: "Garage indépendant à Haren (Bruxelles) : entretien, réparation mécanique, diagnostic électronique, freins et pneus. Prenez rendez-vous en ligne ou par WhatsApp." },
      about: { title: "À propos — Garage indépendant à Haren, Bruxelles", description: "Plus de 25 ans d'expérience en entretien, mécanique et pneus. Découvrez notre atelier indépendant à Haren (Bruxelles) et notre approche du service." },
      mechanical: { title: "Mécanique & entretien auto à Haren, Bruxelles", description: "Entretien périodique, vidange, freins, batterie, diagnostic électronique, suspension, distribution, embrayage, échappement et climatisation. Toutes marques." },
      tires: { title: "Pneus, montage, équilibrage & géométrie à Bruxelles", description: "Montage de pneus, équilibrage, réparation de crevaison, changement saisonnier, géométrie et contrôle de pression. Pneus été, hiver et toutes saisons à Haren." },
      contact: { title: "Contact & rendez-vous — Garage à Haren, Bruxelles", description: "Prenez rendez-vous ou demandez un devis pour votre entretien, réparation ou pneus. Chaussée de Haecht 1900, 1130 Bruxelles. Téléphone, WhatsApp et email." },
    },
    alts: {
      storefront: "Façade du garage Pneu Land Haren, Chaussée de Haecht à Bruxelles",
      mechanicPreview: "Mécanicien Pneu Land Haren réalisant un diagnostic électronique sur une voiture",
      tiresPreview: "Mécanicien manipulant un pneu dans l'atelier",
      aboutHero: "Atelier mécanique de Pneu Land Haren",
      aboutStory: "Intérieur du garage Pneu Land Haren",
      mechanicalHero: "Réparation mécanique sur un moteur dans l'atelier Pneu Land Haren",
      diagnostics: "Diagnostic électronique d'un véhicule au garage",
      tiresHero: "Équilibrage d'une roue dans l'atelier pneus",
      contactHero: "Serrage des boulons d'une roue avec une clé à chocs",
    },
    nav: { home: "Accueil", about: "À propos", mechanical: "Mécanique", tires: "Pneus", contact: "Contact" },
    cta: {
      book: "Prendre rendez-vous",
      discover: "Découvrir nos services",
      call: "Nous appeler",
      quote: "Demander un devis",
      tireQuote: "Demander une offre pneus",
      seeMechanical: "Voir nos services mécaniques",
      seeTires: "Découvrir nos services pneus",
      offer: "Demander une offre",
      learnMore: "En savoir plus",
      route: "Voir l'itinéraire",
      whatsapp: "WhatsApp",
      whatsappMessage: "Bonjour, je souhaite prendre rendez-vous chez Pneu Land Haren.",
      whatsappService: "Bonjour, je souhaite prendre rendez-vous chez Pneu Land Haren pour : {service}.",
      askWhatsapp: "Demander via WhatsApp",
      appointment: "Rendez-vous",
    },
    hero: {
      overline: "Garage & Centre Pneus — Bruxelles",
      title: ["Votre spécialiste", "entretien, mécanique", "et pneus"],
      subtitle: "Un service professionnel pour l'entretien, la réparation et les pneus de votre véhicule.",
      phone: "Téléphone", address: "Adresse", hours: "Horaires",
    },
    quickServices: {
      overline: "Nos prestations",
      title: "Un savoir-faire complet",
      items: [
        { name: "Entretien", desc: "Vidange, révision et entretien périodique complet." },
        { name: "Réparation mécanique", desc: "Diagnostic et réparation de tous types de pannes." },
        { name: "Freins", desc: "Plaquettes, disques et contrôle du système de freinage." },
        { name: "Diagnostic", desc: "Lecture électronique et recherche de pannes." },
        { name: "Climatisation", desc: "Recharge, entretien et désinfection du circuit." },
        { name: "Pneus", desc: "Montage, équilibrage et géométrie de précision." },
      ],
    },
    mechPreview: {
      overline: "01 — Atelier",
      title: "Mécanique & Entretien",
      intro: "Un entretien professionnel et des réparations précises pour garder votre véhicule fiable, sûr et performant kilomètre après kilomètre.",
      list: ["Vidange", "Entretien périodique", "Freins", "Batterie", "Diagnostic", "Suspension", "Courroie de distribution", "Embrayage", "Climatisation", "Réparations générales"],
    },
    tiresPreview: {
      marquee: "PNEUS PREMIUM · GÉOMÉTRIE · ÉQUILIBRAGE ·",
      overline: "02 — Pneumatiques",
      title: "Pneus & Services Pneumatiques",
      items: ["Montage de pneus", "Équilibrage", "Réparation de pneus", "Changement saisonnier", "Géométrie / parallélisme", "Pneus été", "Pneus hiver", "Pneus toutes saisons"],
    },
    why: {
      overline: "03 — Pourquoi nous",
      title: "Pourquoi nous choisir",
      items: [
        { n: "01", name: "Service professionnel", desc: "Des techniciens expérimentés au service de votre sécurité." },
        { n: "02", name: "Équipement moderne", desc: "Un atelier équipé des dernières technologies de diagnostic." },
        { n: "03", name: "Communication transparente", desc: "Des explications claires et des devis sans surprise." },
        { n: "04", name: "Rendez-vous rapide", desc: "Une prise en charge rapide et flexible de votre véhicule." },
      ],
    },
    finalCta: {
      title: "Besoin d'un entretien ou d'une réparation ?",
      text: "Contactez-nous ou envoyez votre demande de rendez-vous.",
    },
    about: {
      heroTitle: "À propos de nous",
      heroSub: "L'atelier de confiance pour votre véhicule à Bruxelles.",
      storyTitle: "Notre histoire",
      story: "Avec plus de 25 ans d'expérience dans le secteur, nous offrons à votre véhicule bien plus qu'une simple intervention technique : un service fiable, transparent et soigné. Dans notre garage indépendant, nous associons le savoir-faire traditionnel aux technologies modernes de diagnostic et de détection de pannes. Quels que soient la marque et le modèle, nous examinons chaque véhicule avec la même rigueur et vous expliquons clairement les interventions nécessaires.",
      story2: "Pour nous, un bon service, c'est un travail bien fait, une communication claire et une confiance qui dure des années. Notre objectif n'est pas seulement de remettre votre véhicule sur la route, mais de vous offrir une expérience que vous choisirez en toute sérénité à chaque visite.",
      values: ["Plus de 25 ans d'expérience", "Toutes marques et modèles", "Tarification transparente", "Service axé sur le client"],
      whyTitle: "Pourquoi nous choisir ?",
    },
    mechanicalPage: {
      heroTitle: "Mécanique & Entretien",
      heroSub: "Des solutions professionnelles pour l'entretien et la réparation de votre véhicule.",
      blocks: [
        { name: "Entretien périodique", desc: "Respect du carnet d'entretien constructeur." },
        { name: "Vidange", desc: "Huile et filtres adaptés à votre moteur." },
        { name: "Service de freinage", desc: "Plaquettes, disques et liquide de frein." },
        { name: "Batterie", desc: "Test, remplacement et contrôle de charge." },
        { name: "Diagnostic électronique", desc: "Lecture des codes défauts et calibrage." },
        { name: "Suspension", desc: "Rotules, bras et silentblocs." },
        { name: "Amortisseurs", desc: "Contrôle et remplacement pour votre confort." },
        { name: "Courroie de distribution", desc: "Remplacement selon les préconisations." },
        { name: "Embrayage", desc: "Diagnostic et remplacement complet." },
        { name: "Échappement", desc: "Ligne, silencieux et catalyseur." },
        { name: "Climatisation", desc: "Recharge gaz et entretien du circuit." },
        { name: "Réparation mécanique générale", desc: "Toutes interventions, toutes marques." },
      ],
      endTitle: "Un problème avec votre véhicule ?",
    },
    tiresPage: {
      heroTitle: "Pneus & Services Pneumatiques",
      heroSub: "Des services pneumatiques professionnels pour une tenue de route et une sécurité optimales.",
      brandsOverline: "Nos marques",
      brandsTitle: "Les plus grandes marques de pneus, disponibles chez nous",
      cards: [
        { name: "Montage de pneus", desc: "Montage soigné sur tous types de jantes." },
        { name: "Équilibrage", desc: "Un roulage sans vibrations." },
        { name: "Réparation de crevaison", desc: "Réparation sûre et durable." },
        { name: "Changement saisonnier", desc: "Passage été / hiver rapide." },
        { name: "Géométrie", desc: "Parallélisme précis pour une usure régulière." },
        { name: "Contrôle de pression", desc: "Vérification et ajustement gratuits." },
      ],
      chooseTitle: "Choisissez le bon pneu",
      choose: [
        { name: "Pneus été", desc: "Adhérence et performance maximales par temps chaud et sec." },
        { name: "Pneus hiver", desc: "Sécurité optimale sur route froide, humide ou enneigée." },
        { name: "Pneus toutes saisons", desc: "Un compromis polyvalent pour rouler toute l'année." },
      ],
      note: "Contactez-nous pour connaître les pneus disponibles pour votre véhicule.",
    },
    contact: {
      heroTitle: "Prendre rendez-vous",
      heroSub: "Envoyez votre demande, nous vous recontactons rapidement.",
      infoTitle: "Nos coordonnées",
      formTitle: "Demande de rendez-vous",
      fields: {
        name: "Nom", surname: "Prénom", email: "Email", phone: "Téléphone",
        brand: "Marque du véhicule", model: "Modèle", plate: "Plaque d'immatriculation",
        service: "Service souhaité", date: "Date de rendez-vous souhaitée", message: "Message",
      },
      serviceOptions: ["Entretien", "Réparation mécanique", "Freins", "Diagnostic", "Climatisation", "Batterie", "Pneus", "Changement de pneus", "Géométrie", "Autre"],
      privacy: "J'accepte la politique de confidentialité.",
      submit: "Envoyer ma demande",
      sending: "Envoi en cours...",
      success: "Merci. Votre demande a bien été envoyée. Notre équipe vous contactera rapidement.",
      error: "Une erreur est survenue. Veuillez réessayer ou nous appeler.",
      required: "Champs obligatoires",
    },
    hours: { monSat: "Lundi – Samedi", monFri: "Lundi – Vendredi", sat: "Samedi", sun: "Dimanche", closed: "Fermé" },
    footer: {
      tagline: "Votre spécialiste entretien, mécanique et pneus à Bruxelles.",
      company: "Entreprise", services: "Services", useful: "Liens utiles", contact: "Contact",
      companyLinks: ["À propos", "Contact"],
      serviceLinks: ["Services mécaniques", "Entretien", "Diagnostic", "Pneus"],
      usefulLinks: ["Politique de confidentialité", "Politique cookies", "Mentions légales"],
      rights: "Tous droits réservés.",
    },
  },

  nl: {
    langLabel: "Nederlands",
    seo: {
      home: { title: "Onderhoud, mechaniek & banden in Brussel", description: "Onafhankelijke garage in Haren (Brussel): onderhoud, mechanische reparaties, elektronische diagnose, remmen en banden. Maak online of via WhatsApp een afspraak." },
      about: { title: "Over ons — Onafhankelijke garage in Haren, Brussel", description: "Meer dan 25 jaar ervaring in onderhoud, mechaniek en banden. Ontdek onze onafhankelijke werkplaats in Haren (Brussel) en onze aanpak van service." },
      mechanical: { title: "Mechaniek & auto-onderhoud in Haren, Brussel", description: "Periodiek onderhoud, olieverversing, remmen, batterij, elektronische diagnose, ophanging, distributieriem, koppeling, uitlaat en airco. Alle merken." },
      tires: { title: "Banden, montage, balanceren & uitlijning in Brussel", description: "Bandenmontage, balanceren, lekreparatie, seizoenswissel, uitlijning en spanningscontrole. Zomer-, winter- en all-seasonbanden in Haren." },
      contact: { title: "Contact & afspraak — Garage in Haren, Brussel", description: "Maak een afspraak of vraag een offerte voor onderhoud, reparatie of banden. Haachtsesteenweg 1900, 1130 Brussel. Telefoon, WhatsApp en e-mail." },
    },
    alts: {
      storefront: "Gevel van garage Pneu Land Haren, Haachtsesteenweg in Brussel",
      mechanicPreview: "Mecanicien van Pneu Land Haren voert een elektronische diagnose uit op een auto",
      tiresPreview: "Mecanicien hanteert een band in de werkplaats",
      aboutHero: "Werkplaats van Pneu Land Haren",
      aboutStory: "Interieur van garage Pneu Land Haren",
      mechanicalHero: "Mechanische reparatie aan een motor in de werkplaats van Pneu Land Haren",
      diagnostics: "Elektronische diagnose van een voertuig in de garage",
      tiresHero: "Balanceren van een wiel in de bandenwerkplaats",
      contactHero: "Wielbouten aandraaien met een slagmoersleutel",
    },
    nav: { home: "Home", about: "Over ons", mechanical: "Mechaniek", tires: "Banden", contact: "Contact" },
    cta: {
      book: "Afspraak maken", discover: "Ontdek onze diensten", call: "Bel ons", quote: "Offerte aanvragen",
      tireQuote: "Bandenofferte aanvragen", seeMechanical: "Bekijk onze mechaniek", seeTires: "Ontdek onze bandendiensten",
      offer: "Offerte aanvragen", learnMore: "Meer weten", route: "Route bekijken", whatsapp: "WhatsApp", whatsappMessage: "Hallo, ik wil graag een afspraak maken bij Pneu Land Haren.", whatsappService: "Hallo, ik wil graag een afspraak maken bij Pneu Land Haren voor: {service}.", askWhatsapp: "Vraag via WhatsApp", appointment: "Afspraak",
    },
    hero: {
      overline: "Garage & Bandencentrum — Brussel",
      title: ["Uw specialist in", "onderhoud, mechaniek", "en banden"],
      subtitle: "Een professionele service voor onderhoud, reparatie en banden van uw voertuig.",
      phone: "Telefoon", address: "Adres", hours: "Openingsuren",
    },
    quickServices: {
      overline: "Onze diensten", title: "Volledige vakkennis",
      items: [
        { name: "Onderhoud", desc: "Olieverversing, revisie en periodiek onderhoud." },
        { name: "Mechanische reparatie", desc: "Diagnose en reparatie van alle pannes." },
        { name: "Remmen", desc: "Remblokken, schijven en controle van het remsysteem." },
        { name: "Diagnose", desc: "Elektronische uitlezing en foutopsporing." },
        { name: "Airconditioning", desc: "Bijvullen, onderhoud en ontsmetting van het circuit." },
        { name: "Banden", desc: "Montage, balanceren en precieze uitlijning." },
      ],
    },
    mechPreview: {
      overline: "01 — Werkplaats", title: "Mechaniek & Onderhoud",
      intro: "Professioneel onderhoud en precieze reparaties om uw voertuig betrouwbaar, veilig en performant te houden.",
      list: ["Olieverversing", "Periodiek onderhoud", "Remmen", "Batterij", "Diagnose", "Ophanging", "Distributieriem", "Koppeling", "Airco", "Algemene reparaties"],
    },
    tiresPreview: {
      marquee: "PREMIUM BANDEN · UITLIJNING · BALANCEREN ·",
      overline: "02 — Banden", title: "Banden & Bandendiensten",
      items: ["Bandenmontage", "Balanceren", "Bandenreparatie", "Seizoenswissel", "Uitlijning", "Zomerbanden", "Winterbanden", "All-season banden"],
    },
    why: {
      overline: "03 — Waarom wij", title: "Waarom voor ons kiezen",
      items: [
        { n: "01", name: "Professionele service", desc: "Ervaren technici voor uw veiligheid." },
        { n: "02", name: "Moderne apparatuur", desc: "Een werkplaats met de nieuwste diagnosetechnologie." },
        { n: "03", name: "Transparante communicatie", desc: "Duidelijke uitleg en offertes zonder verrassingen." },
        { n: "04", name: "Snelle afspraak", desc: "Een snelle en flexibele opvolging van uw voertuig." },
      ],
    },
    finalCta: { title: "Onderhoud of reparatie nodig?", text: "Neem contact op of stuur uw afspraakaanvraag." },
    about: {
      heroTitle: "Over ons", heroSub: "De vertrouwde werkplaats voor uw voertuig in Brussel.",
      storyTitle: "Ons verhaal",
      story: "Met meer dan 25 jaar ervaring in de sector bieden wij uw voertuig veel meer dan alleen een technische ingreep: een betrouwbare, transparante en verzorgde service. In onze onafhankelijke garage combineren we traditioneel vakmanschap met moderne diagnose- en storingsdetectietechnologie. Ongeacht merk of model onderzoeken we elk voertuig met dezelfde zorg en leggen we u de nodige werkzaamheden duidelijk en begrijpelijk uit.",
      story2: "Goede service betekent voor ons: werk dat correct wordt uitgevoerd, heldere communicatie en klantenvertrouwen dat jarenlang standhoudt. Ons doel is niet alleen uw voertuig weer op de weg krijgen, maar u een service-ervaring bieden die u bij elk bezoek met een gerust hart kiest.",
      values: ["Meer dan 25 jaar ervaring", "Alle merken en modellen", "Transparante prijzen", "Klantgerichte service"],
      whyTitle: "Waarom voor ons kiezen?",
    },
    mechanicalPage: {
      heroTitle: "Mechaniek & Onderhoud",
      heroSub: "Professionele oplossingen voor het onderhoud en de reparatie van uw voertuig.",
      blocks: [
        { name: "Periodiek onderhoud", desc: "Volgens het onderhoudsboekje van de fabrikant." },
        { name: "Olieverversing", desc: "Olie en filters afgestemd op uw motor." },
        { name: "Remservice", desc: "Remblokken, schijven en remvloeistof." },
        { name: "Batterij", desc: "Test, vervanging en laadcontrole." },
        { name: "Elektronische diagnose", desc: "Uitlezen van foutcodes en kalibratie." },
        { name: "Ophanging", desc: "Kogelgewrichten, armen en silentblocks." },
        { name: "Schokdempers", desc: "Controle en vervanging voor uw comfort." },
        { name: "Distributieriem", desc: "Vervanging volgens de voorschriften." },
        { name: "Koppeling", desc: "Diagnose en volledige vervanging." },
        { name: "Uitlaat", desc: "Uitlaatlijn, demper en katalysator." },
        { name: "Airconditioning", desc: "Gas bijvullen en onderhoud van het circuit." },
        { name: "Algemene mechanische reparatie", desc: "Alle interventies, alle merken." },
      ],
      endTitle: "Een probleem met uw voertuig?",
    },
    tiresPage: {
      heroTitle: "Banden & Bandendiensten",
      heroSub: "Professionele bandendiensten voor optimale grip en veiligheid.",
      brandsOverline: "Onze merken",
      brandsTitle: "De grootste bandenmerken, bij ons verkrijgbaar",
      cards: [
        { name: "Bandenmontage", desc: "Zorgvuldige montage op alle velgen." },
        { name: "Balanceren", desc: "Rijden zonder trillingen." },
        { name: "Lekreparatie", desc: "Veilige en duurzame reparatie." },
        { name: "Seizoenswissel", desc: "Snelle wissel zomer / winter." },
        { name: "Uitlijning", desc: "Precieze uitlijning voor gelijkmatige slijtage." },
        { name: "Spanningscontrole", desc: "Gratis controle en bijstellen." },
      ],
      chooseTitle: "Kies de juiste band",
      choose: [
        { name: "Zomerbanden", desc: "Maximale grip en prestaties bij warm en droog weer." },
        { name: "Winterbanden", desc: "Optimale veiligheid op koude, natte of besneeuwde wegen." },
        { name: "All-season banden", desc: "Een veelzijdig compromis om het hele jaar te rijden." },
      ],
      note: "Neem contact met ons op voor de banden die beschikbaar zijn voor uw voertuig.",
    },
    contact: {
      heroTitle: "Afspraak maken", heroSub: "Stuur uw aanvraag, wij nemen snel contact op.",
      infoTitle: "Onze gegevens", formTitle: "Afspraakaanvraag",
      fields: { name: "Naam", surname: "Voornaam", email: "Email", phone: "Telefoon", brand: "Merk voertuig", model: "Model", plate: "Nummerplaat", service: "Gewenste dienst", date: "Gewenste afspraakdatum", message: "Bericht" },
      serviceOptions: ["Onderhoud", "Mechanische reparatie", "Remmen", "Diagnose", "Airconditioning", "Batterij", "Banden", "Bandenwissel", "Uitlijning", "Andere"],
      privacy: "Ik aanvaard het privacybeleid.",
      submit: "Mijn aanvraag versturen", sending: "Bezig met versturen...",
      success: "Bedankt. Uw aanvraag is goed verzonden. Ons team neemt snel contact met u op.",
      error: "Er is een fout opgetreden. Probeer opnieuw of bel ons.", required: "Verplichte velden",
    },
    hours: { monSat: "Maandag – Zaterdag", monFri: "Maandag – Vrijdag", sat: "Zaterdag", sun: "Zondag", closed: "Gesloten" },
    footer: {
      tagline: "Uw specialist in onderhoud, mechaniek en banden in Brussel.",
      company: "Bedrijf", services: "Diensten", useful: "Nuttige links", contact: "Contact",
      companyLinks: ["Over ons", "Contact"],
      serviceLinks: ["Mechanische diensten", "Onderhoud", "Diagnose", "Banden"],
      usefulLinks: ["Privacybeleid", "Cookiebeleid", "Wettelijke vermeldingen"],
      rights: "Alle rechten voorbehouden.",
    },
  },

  tr: {
    langLabel: "Türkçe",
    seo: {
      home: { title: "Brüksel'de bakım, mekanik ve lastik", description: "Haren (Brüksel) bölgesinde bağımsız garaj: periyodik bakım, mekanik onarım, elektronik teşhis, fren ve lastik hizmetleri. Online veya WhatsApp ile randevu alın." },
      about: { title: "Hakkımızda — Haren, Brüksel'de bağımsız garaj", description: "Bakım, mekanik ve lastikte 25 yılı aşkın deneyim. Haren'deki (Brüksel) bağımsız atölyemizi ve hizmet anlayışımızı keşfedin." },
      mechanical: { title: "Haren, Brüksel'de mekanik ve araç bakımı", description: "Periyodik bakım, yağ değişimi, fren, akü, elektronik teşhis, süspansiyon, triger kayışı, debriyaj, egzoz ve klima. Tüm markalar." },
      tires: { title: "Brüksel'de lastik, montaj, balans ve rot ayarı", description: "Lastik montajı, balans, patlak tamiri, mevsimlik değişim, rot ayarı ve basınç kontrolü. Haren'de yaz, kış ve dört mevsim lastikler." },
      contact: { title: "İletişim ve randevu — Haren, Brüksel'de garaj", description: "Bakım, onarım veya lastik için randevu alın ya da teklif isteyin. Chaussée de Haecht 1900, 1130 Brüksel. Telefon, WhatsApp ve e-posta." },
    },
    alts: {
      storefront: "Pneu Land Haren garajının Brüksel Chaussée de Haecht'teki cephesi",
      mechanicPreview: "Pneu Land Haren teknisyeni bir araçta elektronik teşhis yapıyor",
      tiresPreview: "Atölyede lastik tutan teknisyen",
      aboutHero: "Pneu Land Haren mekanik atölyesi",
      aboutStory: "Pneu Land Haren garajının içi",
      mechanicalHero: "Pneu Land Haren atölyesinde motor üzerinde mekanik onarım",
      diagnostics: "Garajda araç elektronik teşhisi",
      tiresHero: "Lastik atölyesinde jant balansı",
      contactHero: "Darbeli anahtarla bijon sıkma",
    },
    nav: { home: "Ana Sayfa", about: "Hakkımızda", mechanical: "Mekanik", tires: "Lastik", contact: "İletişim" },
    cta: {
      book: "Randevu al", discover: "Hizmetlerimizi keşfedin", call: "Bizi arayın", quote: "Teklif iste",
      tireQuote: "Lastik teklifi iste", seeMechanical: "Mekanik hizmetlerimiz", seeTires: "Lastik hizmetlerimiz",
      offer: "Teklif iste", learnMore: "Daha fazla", route: "Yol tarifi", whatsapp: "WhatsApp", whatsappMessage: "Merhaba, Pneu Land Haren'den randevu almak istiyorum.", whatsappService: "Merhaba, Pneu Land Haren'den şu hizmet için randevu almak istiyorum: {service}.", askWhatsapp: "WhatsApp ile sor", appointment: "Randevu",
    },
    hero: {
      overline: "Servis & Lastik Merkezi — Brüksel",
      title: ["Bakım, mekanik ve", "lastik konusunda", "uzmanınız"],
      subtitle: "Aracınızın bakımı, onarımı ve lastikleri için profesyonel hizmet.",
      phone: "Telefon", address: "Adres", hours: "Çalışma saatleri",
    },
    quickServices: {
      overline: "Hizmetlerimiz", title: "Eksiksiz uzmanlık",
      items: [
        { name: "Bakım", desc: "Yağ değişimi, revizyon ve periyodik bakım." },
        { name: "Mekanik onarım", desc: "Her türlü arızanın teşhisi ve onarımı." },
        { name: "Frenler", desc: "Balata, disk ve fren sistemi kontrolü." },
        { name: "Teşhis", desc: "Elektronik okuma ve arıza tespiti." },
        { name: "Klima", desc: "Gaz dolumu, bakım ve dezenfeksiyon." },
        { name: "Lastikler", desc: "Montaj, balans ve hassas rot ayarı." },
      ],
    },
    mechPreview: {
      overline: "01 — Atölye", title: "Mekanik & Bakım",
      intro: "Aracınızı güvenilir, güvenli ve performanslı tutmak için profesyonel bakım ve hassas onarım.",
      list: ["Yağ değişimi", "Periyodik bakım", "Frenler", "Akü", "Teşhis", "Süspansiyon", "Triger kayışı", "Debriyaj", "Klima", "Genel onarım"],
    },
    tiresPreview: {
      marquee: "PREMIUM LASTİK · ROT AYARI · BALANS ·",
      overline: "02 — Lastik", title: "Lastik & Lastik Hizmetleri",
      items: ["Lastik montajı", "Balans", "Lastik tamiri", "Mevsimlik değişim", "Rot ayarı", "Yaz lastiği", "Kış lastiği", "Dört mevsim lastik"],
    },
    why: {
      overline: "03 — Neden biz", title: "Neden bizi seçmelisiniz",
      items: [
        { n: "01", name: "Profesyonel hizmet", desc: "Güvenliğiniz için deneyimli teknisyenler." },
        { n: "02", name: "Modern ekipman", desc: "En son teşhis teknolojisine sahip atölye." },
        { n: "03", name: "Şeffaf iletişim", desc: "Açık açıklamalar ve sürprizsiz teklifler." },
        { n: "04", name: "Hızlı randevu", desc: "Aracınız için hızlı ve esnek hizmet." },
      ],
    },
    finalCta: { title: "Bakım veya onarıma mı ihtiyacınız var?", text: "Bizimle iletişime geçin veya randevu talebinizi gönderin." },
    about: {
      heroTitle: "Hakkımızda", heroSub: "Brüksel'de aracınız için güvenilir atölye.",
      storyTitle: "Hikayemiz",
      story: "25 yılı aşkın sektör deneyimimizle, aracınıza yalnızca teknik bir işlem değil; güvenilir, şeffaf ve özenli bir hizmet sunuyoruz. Bağımsız garajımızda geleneksel ustalığı modern arıza tespit ve teşhis teknolojileriyle bir araya getiriyoruz. Markası veya modeli ne olursa olsun her aracı aynı titizlikle inceliyor, ihtiyaç duyduğu işlemleri açık ve anlaşılır şekilde sizinle paylaşıyoruz.",
      story2: "Bizim için iyi hizmet; doğru yapılan iş, net iletişim ve uzun yıllar devam eden müşteri güveni demektir. Amacımız yalnızca aracınızı yeniden yola çıkarmak değil, her ziyaretinizde gönül rahatlığıyla tercih edebileceğiniz bir servis deneyimi sunmaktır.",
      values: ["25+ Yıllık Deneyim", "Tüm Marka ve Modeller", "Şeffaf Fiyatlandırma", "Müşteri Odaklı Hizmet"],
      whyTitle: "Neden bizi seçmelisiniz?",
    },
    mechanicalPage: {
      heroTitle: "Mekanik & Bakım",
      heroSub: "Aracınızın bakımı ve onarımı için profesyonel çözümler.",
      blocks: [
        { name: "Periyodik bakım", desc: "Üreticinin bakım kitabına uygun." },
        { name: "Yağ değişimi", desc: "Motorunuza uygun yağ ve filtreler." },
        { name: "Fren servisi", desc: "Balata, disk ve fren hidroliği." },
        { name: "Akü", desc: "Test, değişim ve şarj kontrolü." },
        { name: "Elektronik teşhis", desc: "Arıza kodu okuma ve kalibrasyon." },
        { name: "Süspansiyon", desc: "Rotil, salıncak ve burçlar." },
        { name: "Amortisörler", desc: "Konforunuz için kontrol ve değişim." },
        { name: "Triger kayışı", desc: "Önerilere göre değişim." },
        { name: "Debriyaj", desc: "Teşhis ve komple değişim." },
        { name: "Egzoz", desc: "Egzoz hattı, susturucu ve katalizör." },
        { name: "Klima", desc: "Gaz dolumu ve devre bakımı." },
        { name: "Genel mekanik onarım", desc: "Tüm işlemler, tüm markalar." },
      ],
      endTitle: "Aracınızla ilgili bir sorun mu var?",
    },
    tiresPage: {
      heroTitle: "Lastik & Lastik Hizmetleri",
      heroSub: "Optimum yol tutuş ve güvenlik için profesyonel lastik hizmetleri.",
      brandsOverline: "Markalarımız",
      brandsTitle: "En büyük lastik markaları, bizde mevcut",
      cards: [
        { name: "Lastik montajı", desc: "Tüm jantlara özenli montaj." },
        { name: "Balans", desc: "Titreşimsiz sürüş." },
        { name: "Patlak tamiri", desc: "Güvenli ve kalıcı onarım." },
        { name: "Mevsimlik değişim", desc: "Hızlı yaz / kış değişimi." },
        { name: "Rot ayarı", desc: "Düzgün aşınma için hassas ayar." },
        { name: "Basınç kontrolü", desc: "Ücretsiz kontrol ve ayar." },
      ],
      chooseTitle: "Doğru lastiği seçin",
      choose: [
        { name: "Yaz lastikleri", desc: "Sıcak ve kuru havada maksimum tutuş ve performans." },
        { name: "Kış lastikleri", desc: "Soğuk, ıslak veya karlı yolda optimum güvenlik." },
        { name: "Dört mevsim lastikler", desc: "Tüm yıl sürüş için çok yönlü bir denge." },
      ],
      note: "Aracınız için mevcut lastikleri öğrenmek için bizimle iletişime geçin.",
    },
    contact: {
      heroTitle: "Randevu al", heroSub: "Talebinizi gönderin, en kısa sürede geri dönelim.",
      infoTitle: "İletişim bilgilerimiz", formTitle: "Randevu talebi",
      fields: { name: "Ad", surname: "Soyad", email: "Email", phone: "Telefon", brand: "Araç markası", model: "Model", plate: "Plaka", service: "İstenen hizmet", date: "Tercih edilen randevu tarihi", message: "Mesaj" },
      serviceOptions: ["Bakım", "Mekanik onarım", "Frenler", "Teşhis", "Klima", "Akü", "Lastikler", "Lastik değişimi", "Rot ayarı", "Diğer"],
      privacy: "Gizlilik politikasını kabul ediyorum.",
      submit: "Talebimi gönder", sending: "Gönderiliyor...",
      success: "Teşekkürler. Talebiniz başarıyla gönderildi. Ekibimiz en kısa sürede sizinle iletişime geçecek.",
      error: "Bir hata oluştu. Lütfen tekrar deneyin veya bizi arayın.", required: "Zorunlu alanlar",
    },
    hours: { monSat: "Pazartesi – Cumartesi", monFri: "Pazartesi – Cuma", sat: "Cumartesi", sun: "Pazar", closed: "Kapalı" },
    footer: {
      tagline: "Brüksel'de bakım, mekanik ve lastik uzmanınız.",
      company: "Şirket", services: "Hizmetler", useful: "Faydalı bağlantılar", contact: "İletişim",
      companyLinks: ["Hakkımızda", "İletişim"],
      serviceLinks: ["Mekanik hizmetler", "Bakım", "Teşhis", "Lastikler"],
      usefulLinks: ["Gizlilik politikası", "Çerez politikası", "Yasal uyarı"],
      rights: "Tüm hakları saklıdır.",
    },
  },

  en: {
    langLabel: "English",
    seo: {
      home: { title: "Maintenance, mechanics & tires in Brussels", description: "Independent garage in Haren (Brussels): car maintenance, mechanical repairs, electronic diagnostics, brakes and tires. Book online or via WhatsApp." },
      about: { title: "About us — Independent garage in Haren, Brussels", description: "Over 25 years of experience in maintenance, mechanics and tires. Discover our independent workshop in Haren (Brussels) and our approach to service." },
      mechanical: { title: "Mechanics & car maintenance in Haren, Brussels", description: "Periodic maintenance, oil change, brakes, battery, electronic diagnostics, suspension, timing belt, clutch, exhaust and air conditioning. All makes." },
      tires: { title: "Tires, fitting, balancing & wheel alignment in Brussels", description: "Tire fitting, wheel balancing, puncture repair, seasonal changes, wheel alignment and pressure checks. Summer, winter and all-season tires in Haren." },
      contact: { title: "Contact & appointment — Garage in Haren, Brussels", description: "Book an appointment or request a quote for maintenance, repairs or tires. Chaussée de Haecht 1900, 1130 Brussels. Phone, WhatsApp and email." },
    },
    alts: {
      storefront: "Pneu Land Haren garage storefront on Chaussée de Haecht, Brussels",
      mechanicPreview: "Pneu Land Haren mechanic running electronic diagnostics on a car",
      tiresPreview: "Mechanic handling a tire in the workshop",
      aboutHero: "Pneu Land Haren mechanical workshop",
      aboutStory: "Inside the Pneu Land Haren garage",
      mechanicalHero: "Mechanical repair on an engine at the Pneu Land Haren workshop",
      diagnostics: "Electronic vehicle diagnostics at the garage",
      tiresHero: "Wheel balancing in the tire workshop",
      contactHero: "Tightening wheel bolts with an impact wrench",
    },
    nav: { home: "Home", about: "About Us", mechanical: "Mechanical", tires: "Tires", contact: "Contact" },
    cta: {
      book: "Book Appointment", discover: "Discover our services", call: "Call us", quote: "Request a quote",
      tireQuote: "Request a tire quote", seeMechanical: "See our mechanical services", seeTires: "Discover our tire services",
      offer: "Request an offer", learnMore: "Learn more", route: "Get directions", whatsapp: "WhatsApp", whatsappMessage: "Hello, I would like to book an appointment at Pneu Land Haren.", whatsappService: "Hello, I would like to book an appointment at Pneu Land Haren for: {service}.", askWhatsapp: "Ask via WhatsApp", appointment: "Appointment",
    },
    hero: {
      overline: "Garage & Tire Center — Brussels",
      title: ["Your specialist in", "maintenance, mechanics", "and tires"],
      subtitle: "Professional service for the maintenance, repair and tires of your vehicle.",
      phone: "Phone", address: "Address", hours: "Opening hours",
    },
    quickServices: {
      overline: "Our services", title: "Complete expertise",
      items: [
        { name: "Maintenance", desc: "Oil change, servicing and full periodic maintenance." },
        { name: "Mechanical Repair", desc: "Diagnosis and repair of all types of faults." },
        { name: "Brakes", desc: "Pads, discs and full braking system check." },
        { name: "Diagnostics", desc: "Electronic reading and fault finding." },
        { name: "Air Conditioning", desc: "Recharge, servicing and circuit disinfection." },
        { name: "Tires", desc: "Fitting, balancing and precision alignment." },
      ],
    },
    mechPreview: {
      overline: "01 — Workshop", title: "Mechanics & Maintenance",
      intro: "Professional maintenance and precise repairs to keep your vehicle reliable, safe and performing mile after mile.",
      list: ["Oil change", "Periodic maintenance", "Brakes", "Battery", "Diagnostics", "Suspension", "Timing belt", "Clutch", "Air conditioning", "General repairs"],
    },
    tiresPreview: {
      marquee: "PREMIUM TIRES · WHEEL ALIGNMENT · BALANCING ·",
      overline: "02 — Tires", title: "Tires & Tire Services",
      items: ["Tire installation", "Balancing", "Tire repair", "Seasonal change", "Wheel alignment", "Summer tires", "Winter tires", "All-season tires"],
    },
    why: {
      overline: "03 — Why us", title: "Why choose us",
      items: [
        { n: "01", name: "Professional Service", desc: "Experienced technicians dedicated to your safety." },
        { n: "02", name: "Modern Equipment", desc: "A workshop fitted with the latest diagnostic technology." },
        { n: "03", name: "Transparent Communication", desc: "Clear explanations and quotes with no surprises." },
        { n: "04", name: "Fast Appointment", desc: "Fast and flexible handling of your vehicle." },
      ],
    },
    finalCta: { title: "Need maintenance or a repair?", text: "Contact us or send your appointment request." },
    about: {
      heroTitle: "About Us", heroSub: "The trusted workshop for your vehicle in Brussels.",
      storyTitle: "Our story",
      story: "With over 25 years of experience in the industry, we offer your vehicle far more than a simple technical intervention: a reliable, transparent and attentive service. In our independent garage, we combine traditional craftsmanship with modern fault-detection and diagnostic technology. Whatever the make or model, we inspect every vehicle with the same care and explain the necessary work to you clearly and understandably.",
      story2: "For us, good service means work done right, clear communication and customer trust that lasts for years. Our goal is not only to get your vehicle back on the road, but to offer you a service experience you can choose with complete peace of mind on every visit.",
      values: ["Over 25 years of experience", "All makes and models", "Transparent pricing", "Customer-focused service"],
      whyTitle: "Why choose us?",
    },
    mechanicalPage: {
      heroTitle: "Mechanics & Maintenance",
      heroSub: "Professional solutions for the maintenance and repair of your vehicle.",
      blocks: [
        { name: "Periodic maintenance", desc: "Following the manufacturer's service schedule." },
        { name: "Oil change", desc: "Oil and filters suited to your engine." },
        { name: "Brake service", desc: "Pads, discs and brake fluid." },
        { name: "Battery", desc: "Testing, replacement and charge check." },
        { name: "Electronic diagnostics", desc: "Fault-code reading and calibration." },
        { name: "Suspension", desc: "Ball joints, arms and bushings." },
        { name: "Shock absorbers", desc: "Inspection and replacement for your comfort." },
        { name: "Timing belt", desc: "Replacement according to recommendations." },
        { name: "Clutch", desc: "Diagnosis and full replacement." },
        { name: "Exhaust", desc: "Exhaust line, silencer and catalytic converter." },
        { name: "Air conditioning", desc: "Gas recharge and circuit servicing." },
        { name: "General mechanical repair", desc: "All interventions, all brands." },
      ],
      endTitle: "A problem with your vehicle?",
    },
    tiresPage: {
      heroTitle: "Tires & Tire Services",
      heroSub: "Professional tire services for optimal road grip and safety.",
      brandsOverline: "Our brands",
      brandsTitle: "The leading tire brands, available in-store",
      cards: [
        { name: "Tire installation", desc: "Careful fitting on all types of rims." },
        { name: "Balancing", desc: "Vibration-free driving." },
        { name: "Puncture repair", desc: "Safe and durable repair." },
        { name: "Seasonal tire change", desc: "Fast summer / winter swap." },
        { name: "Wheel alignment", desc: "Precise alignment for even wear." },
        { name: "Tire pressure check", desc: "Free check and adjustment." },
      ],
      chooseTitle: "Choose the right tire",
      choose: [
        { name: "Summer Tires", desc: "Maximum grip and performance in warm, dry weather." },
        { name: "Winter Tires", desc: "Optimal safety on cold, wet or snowy roads." },
        { name: "All-Season Tires", desc: "A versatile compromise to drive all year round." },
      ],
      note: "Contact us to find out which tires are available for your vehicle.",
    },
    contact: {
      heroTitle: "Book Appointment", heroSub: "Send your request and we'll get back to you quickly.",
      infoTitle: "Our details", formTitle: "Appointment request",
      fields: { name: "Name", surname: "Surname", email: "Email", phone: "Phone", brand: "Vehicle brand", model: "Vehicle model", plate: "License plate", service: "Desired service", date: "Preferred appointment date", message: "Message" },
      serviceOptions: ["Maintenance", "Mechanical Repair", "Brakes", "Diagnostics", "Air Conditioning", "Battery", "Tires", "Tire Change", "Wheel Alignment", "Other"],
      privacy: "I accept the privacy policy.",
      submit: "Send my request", sending: "Sending...",
      success: "Thank you. Your request has been sent successfully. Our team will contact you shortly.",
      error: "Something went wrong. Please try again or call us.", required: "Required fields",
    },
    hours: { monSat: "Monday – Saturday", monFri: "Monday – Friday", sat: "Saturday", sun: "Sunday", closed: "Closed" },
    footer: {
      tagline: "Your specialist in maintenance, mechanics and tires in Brussels.",
      company: "Company", services: "Services", useful: "Useful Links", contact: "Contact",
      companyLinks: ["About Us", "Contact"],
      serviceLinks: ["Mechanical Services", "Maintenance", "Diagnostics", "Tires"],
      usefulLinks: ["Privacy Policy", "Cookie Policy", "Legal Notice"],
      rights: "All rights reserved.",
    },
  },
};

export const LANGS = ["fr", "nl", "tr", "en"];
export const DEFAULT_LANG = "fr";

// Localized route slugs per page key.
export const pageSlugs = {
  home: { fr: "", nl: "", tr: "", en: "" },
  mechanical: { fr: "mecanique", nl: "mechaniek", tr: "mekanik", en: "mechanical-services" },
  tires: { fr: "pneus", nl: "banden", tr: "lastik", en: "tires" },
  about: { fr: "a-propos", nl: "over-ons", tr: "hakkimizda", en: "about" },
  contact: { fr: "contact", nl: "contact", tr: "iletisim", en: "contact" },
};

export const pathFor = (lang, pageKey) => {
  const slug = pageSlugs[pageKey][lang];
  return slug ? `/${lang}/${slug}` : `/${lang}`;
};
